module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2019_13.f1cbbf3c.jpg";